import { render } from "./projects.vue?vue&type=template&id=9b5af64a&scoped=true"
import script from "./projects.js?vue&type=script&lang=js"
export * from "./projects.js?vue&type=script&lang=js"

import "./projects.vue?vue&type=style&index=0&id=9b5af64a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b5af64a"]])

export default __exports__